export default{
   showToast({commit}, payload){
    commit('SET_TOAST', payload)
   },
   toggleOffToastVisibility({commit}, visibilityStatus){
      commit('SET_TOAST_VISIBLE_STATE', visibilityStatus)
   }
}